<div class="date-range-container">
  <div class="date-column">
    <h2>
      {{ "phrases.start_date" | translate }}:
      {{ startDate | date: "MMM d, y" : undefined : currentLang }}
    </h2>
    <mat-calendar
      *ngIf="renderCalendars"
      [(selected)]="startDate"
      (selectedChange)="onStartSelect($event)"
      [startAt]="startDate"
      [maxDate]="endDate"
      [dateClass]="dateRangeClass"
    ></mat-calendar>
  </div>

  <div class="date-column">
    <h2>
      {{ "phrases.end_date" | translate }}:
      {{ endDate | date: "MMM d, y" : undefined : currentLang }}
    </h2>
    <mat-calendar
      *ngIf="renderCalendars"
      [(selected)]="endDate"
      (selectedChange)="onEndSelect($event)"
      [minDate]="startDate"
      [startAt]="endDate || startDate"
      [maxDate]="maxDate"
      [dateClass]="dateRangeClass"
    ></mat-calendar>
  </div>
</div>

<div class="date-range-buttons">
  <button mat-button (click)="onCancel()">
    {{ "words.cancel" | translate }}
  </button>
  <button mat-raised-button class="primary" (click)="onApply()">
    {{ "words.apply" | translate }}
  </button>
</div>
